import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";

import {
    svgPauseMedia,
    svgFwButton,
    svgRwButton,
    svgVolumeOnButton,
    svgVolumeMuteButton,
    svgSubscribeButton,
    svgCloseButton,
    svgPlayMedia,
    SvgRegistryService,
    SvgIconComponent,
} from "@hermes/aphrodite/svg";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { CHAPTERS_COMPONENT } from "../../core";

import { PodcastAnalyticsService } from "./podcast-analytics.service";
import { PodcastComponent } from "./podcast.component";

@NgModule({
    declarations: [PodcastComponent],
    providers: [
        DatePipe,
        { provide: CHAPTERS_COMPONENT, useValue: PodcastComponent },
        PodcastAnalyticsService,
    ],
    imports: [CommonModule, SvgIconComponent, SrOnlyNoSnippetDirective],
})
export class PodcastModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([
            svgPlayMedia,
            svgPauseMedia,
            svgFwButton,
            svgRwButton,
            svgVolumeOnButton,
            svgVolumeMuteButton,
            svgSubscribeButton,
            svgCloseButton,
        ]);
    }
}
